import { MenuItem } from '../models/menu.model';

export const MENU_ITEMS: MenuItem[] = [
  { label: 'Compromisos', icon: 'pi pi-wallet', path: '/compromisos', permission: 'module:commitments' },
  { label: 'Equipo', icon: 'pi pi-users', path: '/equipo', permission: 'module:professionals' },
  { label: 'Movimientos', icon: 'pi pi-arrow-right-arrow-left', path: '/movimientos', permission: 'module:movements' },
  { label: 'Pacientes', icon: 'pi pi-id-card', path: '/pacientes', permission: 'module:patients' },
  { label: 'Reporte Financiero', icon: 'pi pi-chart-line', path: '/reporte-financiero', permission: 'reports:read' },
  {
    label: 'Configuración',
    icon: 'pi pi-cog',
    permission: 'module:configs',
    children: [
      { label: 'Frecuencias', icon: 'pi pi-bell', path: '/frecuencias-notificacion', permission: 'module:configs' },
    ],
  }
];
